/**
 * 筛选未经选择（可选）的列表
 * @param allList {*[]} 所有列表
 * @param alreadySelectList {*[]} 已选择的列表
 * @param selfSelectList  {*[]} 自己选择的列表
 * @param valueKey  {string|function} itemObject中用来匹配的key或者取值方法
 * @returns {*[]}
 */
export function filterUnselectedList(allList=[],alreadySelectList=[],selfSelectList=[],valueKey=""){
  let getValue = typeof valueKey === "function" ? valueKey : item => item[valueKey];
  let already = alreadySelectList.map(item=>getValue(item,"already"));
  let self = selfSelectList.map(item=>getValue(item,"self"));
  return allList.filter(item=>{
    let value = getValue(item,"all");
    return self.includes(value) || !already.includes(value);
  })
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/filterUnselectedList/utils.js